/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import {
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from 'reactstrap';

const CopyFeaturesModal = ({
    container,
    ids,
    isOpen,
    onClose
}: {
    container: string;
    ids: string[];
    isOpen: boolean;
    onClose: Function;
}) => {
    const close = () => {
        if (onClose !== undefined) onClose();
    };
    return (
        <Modal isOpen={isOpen} toggle={close} container={container}>
            <ModalHeader toggle={close}>Copy Area Selection...</ModalHeader>
            <ModalBody>
                {ids?.length > 0 ? (
                    <Form>
                        <FormGroup>
                            <Label for="featureIds">
                                <b>Copy</b> (CTRL+C) your selection of areas
                                from the box below.
                            </Label>
                            <Input
                                rows="10"
                                type="textarea"
                                name="featureIds"
                                id="featureIds"
                                readOnly={true}
                                defaultValue={ids.join(',')}
                            />
                        </FormGroup>
                    </Form>
                ) : (
                    <div>You havent selected any areas.</div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={close}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default CopyFeaturesModal;
